import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormFieldComponent } from '@pishgamrayan/ng-form-kit';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';

import { environment } from 'src/environments/environment';
import { ShareDirectivesModule } from '../../../core/directives/directives.module';
import { SharePipesModule } from '../../../core/pipes/pipes.module';
import { TranslationModule } from '../../../i18n/translation.module';
import { ListGroupItemModule } from '../../global/list-group-item/list-group-item.module';
import { MaterialModule } from '../../modules/material/material.module';
import { ZonesSelectSearchComponent } from '../select-search/zones-select-search.component';
import { PostalCodeMapSelectorComponent } from './postal-code-map-selector.component';

@NgModule({
  declarations: [PostalCodeMapSelectorComponent],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    TranslationModule,
    ZonesSelectSearchComponent,
    SharePipesModule,
    ShareDirectivesModule,
    ListGroupItemModule,
    FormFieldComponent,
    NgxMapboxGLModule.withConfig({
      accessToken: environment.mapBoxToken,
    }),
  ],
  exports: [PostalCodeMapSelectorComponent],
})
export class PostalCodeSelectorModule {}

